import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { supabase } from '@/lib/supabase';
import { sessionRole } from '@/lib/sessionRole';
import { AppShell } from '@/components/layout/AppShell';

// Standalone dancer access — only allowed if COPPA consent recorded AND
// the dancer is 13+. The RLS policy enforces; this route guard mirrors.

export const Route = createFileRoute('/dancer')({
  beforeLoad: async () => {
    const { data } = await supabase.auth.getSession();
    if (!data.session) throw redirect({ to: '/login' });
    const role = sessionRole(data.session) ?? 'parent';
    if (role !== 'dancer') throw redirect({ to: '/' });
  },
  component: DancerLayout,
});

function DancerLayout() {
  return (
    <AppShell
      role="dancer"
      nav={[
        { to: '/dancer', label: 'Schedule' },
        { to: '/dancer/videos', label: 'Videos' },
        { to: '/dancer/competitions', label: 'Competitions' },
      ]}
    >
      <Outlet />
    </AppShell>
  );
}
